<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-模拟显示-指定商品
    -->
  <div class="drag optional" :class="{ selected: index === selectedIndex }" @click.stop="$parent.$parent.onEditer(index)">
    <div class="diy-special" :style="{ background: item.style.background,backgroundImage: item.style.backgroundImage ? `url('${item.style.backgroundImage}')` : 'none',backgroundRepeat: 'no-repeat',backgroundSize: 'cover' }">
      <div class="diy-head d-b-c" :style="{ color: item.style.color }">
        <div class="left d-s-c">
          <div class="name">指定商品</div>
         
        </div>
        <div class="right">更多</div>
      </div>
      <ul class="product-list" :class="['column__' + item.style.column]" :style="getUlwidth(item)">
        <li class="product-item" v-for="(product_item, index) in product" :key="product_item.product_id || index">
          <!-- 两列三列 -->
          <div class="product-cover">
            <img v-img-url="product_item.image" />
          </div>
          <div class="product-info p-0-10">
            <div v-if="item.style.show.productName == '1'" class="product-title">{{ product_item.product_name }}</div>
            <div class="price d-b-c f12">
                <div v-if="item.style.show.productPrice" class="orange">
                  <span>¥</span>
                  <span class="">{{ product_item.product_price }}</span>
                </div>
                <div class="ml4 gray9 text-d-line" v-if="item.style.show.linePrice && product_item.line_price > 0">
                  ¥{{ product_item.line_price }}
                </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-edit-del"><div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      /*分类id*/
      category_id: 0,
      product: []
    };
  },
  created() {
    // 初始化：确保 data 是数组
    if (this.item) {
      const data = Array.isArray(this.item.data) ? this.item.data : [];
      const hasNewProducts = data.some(product => product.product_id);
      this.product = hasNewProducts 
        ? data.filter(product => product.product_id) 
        : [...data];
    }
  },
  props: ['item', 'index', 'selectedIndex'],
  watch: {
    item: {
      handler(new_value) {
        const self = this;
        // 关键：强制将 data 转为数组（若为 null/undefined 则设为空数组）
        const data = Array.isArray(new_value.data) ? new_value.data : [];
        
        // 检查列表中是否有“新商品”（存在product_id的商品）
        const hasNewProducts = data.some(product => product.product_id);
        if (hasNewProducts) {
          // 有新商品：只保留有product_id的商品（过滤默认商品）
          self.product = data.filter(product => product.product_id);
        } else {
          // 无新商品：保留默认商品
          self.product = [...data];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /*计算宽度*/
    getUlwidth(item) {
      console.log(item.style.display,'item.style.display')
      if (item.style.display == 'slide') {
        let total = 0;
        total=item.data.length;
        let w = 0;
        if (item.style.column == 2) {
          w = total * 150;
        } else {
          w = total * 100;
        }
        return 'width:' + w + 'px;';
      }
    }
  }
};
</script>

<style>
.diy-special {
  border-radius: 10px 10px 0 0;
}
.diy-special .diy-head {
  padding: 0 10px;
  height: 40px;
}
.diy-special .diy-head .name {
  font-size: 18px;
  font-weight: bold;
}
.diy-special .diy-head .datetime {
  margin-left: 20px;
}
.diy-special .diy-head .datetime > span {
  display: inline-block;
}
.diy-special .diy-head .datetime .text {
  padding: 0 4px;
}
.diy-special .diy-head .datetime .box {
  padding: 2px;
  border-radius: 4px;
  background: #000000;
  color: #ffffff;
}
.diy-special .product-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.diy-special .product-list.column__1 .product-item {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px;
  border-bottom: 1px solid #dddddd;
  background: #ffffff;
  width: 100%;
}

.diy-special .product-list.column__1 .product-item-box {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}

.diy-special .product-list.column__1 .product-cover {
  width: 100px;
  height: 100px;
}

.diy-special .product-list.column__1 .product-info {
  margin-left: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.diy-special .product-list .product-title {
  margin-top: 4px;
  height: 40px;
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.diy-special .display__list .column__2,
.diy-special .display__list .column__3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.diy-special .product-list.column__2 .product-item {
  width: 170px;
  margin-bottom: 10px;
  margin-left: 5px;
  background: #ffffff;
}
.diy-special .product-list.column__2 .product-item .product-cover {
  width: 170px;
  height: 170px;
  overflow: hidden;
}

.diy-special .product-list.column__3 .product-item {
  width: 110px;
  margin-bottom: 10px;
  margin-left: 6px;
  background: #ffffff;
}
.diy-special .product-list.column__3 .product-item .product-cover {
  width: 110px;
  height: 110px;
  overflow: hidden;
}
.diy-special .product-list.column__3 .product-item .product-cover img {
  width: 110px;
}

.diy-special .product-list.column__2 .product-title,
.diy-special .product-list.column__3 .product-title {
  height: 40px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/ProductZd.vue